import {
    SET_THEME,
    SET_COLOR_SCHEME,
    SET_COMPONENT_THEME,
    SET_THEME_UPDATE_LOADING
} from "../types/typesTheme";

interface ThemeState {
    theme: string; // layout theme (blue, green, etc.)
    colorScheme: string; // light or dark
    componentTheme: string; // component theme (blue, green, etc.)
    themeUpdateLoading: boolean;
}

const initialState: ThemeState = {
    theme: 'blue',
    colorScheme: 'dark',
    componentTheme: 'blue',
    themeUpdateLoading: false
};

export const ThemeReducer = (state = initialState, action: any): ThemeState => {
    switch (action.type) {
        case SET_THEME:
            return {
                ...state,
                theme: action.payload
            };
        case SET_COLOR_SCHEME:
            return {
                ...state,
                colorScheme: action.payload
            };
        case SET_COMPONENT_THEME:
            return {
                ...state,
                componentTheme: action.payload
            };
        case SET_THEME_UPDATE_LOADING:
            return {
                ...state,
                themeUpdateLoading: action.payload
            };
        default:
            return state;
    }
};
